import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";
import { useDispatch } from "react-redux";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";

const InternalMultiApprovalDeclined = () => {
  const [declinedPageData, setdeclinedPageData] = useState([]);
  const [declinedPageID, setdeclinedPageID] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const lengthVarForConditonOne = 1;

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedData"),
    );

    if (storedSelectedApproval) {
      setdeclinedPageData(storedSelectedApproval?.selectedSendTransactions);
      setdeclinedPageID(storedSelectedApproval.selectedTransactions);
    } else {
      setdeclinedPageData([]);
      setdeclinedPageID([]);
    }
  }, []);

  const buttonRows = [
    [
      {
        btnText: "Reject more transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.APPROVE_MORE_TXN,
        imgColor: "var(--positive-bg)",
        handleFunction: () =>
          navigate(
            "/internal_transaction_dashboard/internal_transaction_multi_approval",
          ),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: () => navigate("/internal_transaction_dashboard"),
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  const TransactionList = ({ transactions }) => (
    <>
      {transactions?.map((txn, i) => (
        <InfoCard
          key={i}
          bgColor="var(--positive-card)"
          hoverable="white"
          onClick={() =>
            navigate(
              `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${txn?.txn_id}`,
            )
          }
          rows={[
            {
              leftTitle: txn?.internal_account_name
                ?.toLowerCase()
                .split(" ")
                .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                .join(" "),
              leftSubTitle: "Account name",
              rightTitleTextColor: "var(--text-primary)",
              rightTextFontWeight: "semibold",
              hasRight: true,
              rightIcon: true,
              rightText: true,
              rightTitle: `INR ${FormatAmount({ price: txn?.amount })}`,
              rightSubTitle: "Amount",
              onClick: () =>
                navigate(
                  `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${txn?.txn_id}`,
                ),
            },
          ]}
        />
      ))}
    </>
  );

  return (
    <>
      <StatusContainer
        status="success"
        buttonRows={buttonRows}
        title={
          declinedPageID?.length === lengthVarForConditonOne
            ? "Transaction has been rejected"
            : declinedPageID?.length > lengthVarForConditonOne
              ? "Transactions have been rejected"
              : "Transactions rejected and sent for recreation"
        }
      >
        <TabsWeapperSection
          title={`Rejected transactions - ${declinedPageID?.length || declinedPageData?.length}`}
        >
          <TransactionList transactions={declinedPageData} />
        </TabsWeapperSection>
      </StatusContainer>
      {/* Component implementation */}
    </>
  );
};

export default InternalMultiApprovalDeclined;
